<template>
  <div class="paypal_step1">
    <div class="paypal_title">请选择购买数量 <span class="tips">(交易会收取8%的手续费用)</span></div>
    <div class="paypal_cont">
      <el-form ref="ruleFormRef2" :model="formLabel2">
        <el-form-item label="购买者钱包">
          <p class="paypal_text">{{ formLabel2.wallet }}</p>
        </el-form-item>
        <el-form-item 
          label="购买数量" 
          prop="number"
          :rules="[
            { required: true, message: '请输入购买数量' },
            { type: 'number', message: '必须是数字' },
          ]">
          <el-input-number style="width: 50%;" @blur="inputNum" v-model="formLabel2.number" :precision="0" :step="1" :min="Min_Num" :max="Max_Num" />
        </el-form-item>
        <el-form-item label="等值USDT">
          <p class="paypal_text">{{ formLabel2.usdt }} &nbsp; USDT</p>
        </el-form-item>
        <el-form-item label="手续费">
          <p class="paypal_text">{{ formLabel2.transaction_fees }} &nbsp; USDT</p>
        </el-form-item>
        <el-form-item>
          <el-button :loading="loading" size="large" type="success" plain style="margin-top: 12px" @click="submitForm2(ruleFormRef2)">确认</el-button>
          <el-button size="large" type="info" plain style="margin-top: 12px" @click="resetForm2(ruleFormRef2)">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted, inject, computed, onBeforeUnmount } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import { ethers } from "ethers";
  import { useRoute, useRouter } from 'vue-router'
  import { getDLCPrice } from "@/api/index.js"
  
  export default defineComponent({
    name: 'paypal',
    emits: ['setBuyData'],
    props: {
      active:  {
        type: [ Number],
        required: true
      },
    },
    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const store = useStore()
      const router = useRouter()
      const route = useRoute()
      const message = inject('$message') 
      const refresh = ref(undefined)
      let lan = computed(() => store.state.lan)
      const dlcprice = ref(0)
      const Max_Num = ref(0)
      const Min_Num = ref(0)
      const formLabel2 = ref({
        wallet: route.query.wallet,
        number: 0,
        buy_price: 0,
        usdt: 0,
        transaction_fees: 0
      })
      const validateAddress = (address) => {
        if (!ethers.utils.isAddress(address)) {
          return {
            message: 'Invalid address format',
            success: false
          }
        }
        if (address === ethers.constants.AddressZero) {
          return {
            message: 'Zero address not allowed',
            success: false
          }
        }
        return {
          message: '"Valid address"',
          success: true
        }
      }

      const loading = ref(false)
      const ruleFormRef2 = ref()
      const inputNum = (val) => {
        formLabel2.value.usdt = Math.ceil((formLabel2.value.number * (dlcprice.value * 100000) / 100000) * 100) / 100
        formLabel2.value.transaction_fees = Math.ceil(formLabel2.value.usdt * 0.08 * 100) / 100
      }
      const submitForm2 = async () => {
        loading.value = true
        if (formLabel2.value.wallet == '') {
          message({
            message: '钱包地址不能为空',
            grouping: true,
            type: 'error'
          })
          loading.value = false
          return false
        }
        if (formLabel2.value.usdt < 0) {
          message({
            message: '购买数量不能为0',
            grouping: true,
            type: 'error'
          })
          loading.value = false
          return false
        }
        if (!(validateAddress(formLabel2.value.wallet).success)){
          message({
            message: '钱包地址无效，请检查地址时候正确',
            grouping: true,
            type: 'error'
          })
          loading.value = false
          return false
        }
        await ruleFormRef2.value.validate( async (valid, fields) => {
          if (valid) {
            formLabel2.value.buy_price = dlcprice.value
            emit('setBuyData', formLabel2.value)
            loading.value = false
          } else {
            loading.value = false
          }
        })
      }
      const resetForm2 = () => {
        router.push('/')
      }
      const getData = async () => {
        const data = await getDLCPrice()
        if (data.content) {
          dlcprice.value = data.content.dlc_price
          Min_Num.value = Math.floor(1 / dlcprice.value)
          Max_Num.value = Math.floor(100 / dlcprice.value)
          formLabel2.value.number = Min_Num.value
          formLabel2.value.usdt = Math.ceil((formLabel2.value.number * (dlcprice.value * 100000) / 100000) * 100) / 100
          formLabel2.value.transaction_fees = Math.ceil(formLabel2.value.usdt * 0.08 * 100) / 100
        }
      }
      onMounted(async () => {
        if (refresh.value) {
          clearInterval(refresh.value)
          refresh.value = null
        }
        await getData()
        refresh.value = setInterval(async () => {
          await getData()
        }, 30000)
      })
      onBeforeUnmount(() => {
        if (refresh.value) {
          clearInterval(refresh.value)
          refresh.value = null
        }
      })
      return {
        lan,
        loading,
        Min_Num,
        Max_Num,
        inputNum,
        formLabel2,
        ruleFormRef2,
        submitForm2,
        resetForm2,
      };
    }
  })
</script>

<style scoped lang="scss">
.paypal_step1 {
  width: 100%;
  margin: 0 auto 60px;
  box-sizing: border-box;
  .paypal_title {
    width: 100%;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 40px;
    font-family: Monda;
    margin: 40px 0 20px;
    .tips {
      font-size: 14px;
    }
  }
  .paypal_cont {
    width: 100%;
    font-size: 22px !important;
    .paypal_text {
      color: #fff;
    }
  }
}

</style>

<style>
.el-form-item__label {
  color: #fff !important;
}
</style>